export enum HeartRateSource {
    Wrist = 1,
    InsideOfAnElbow = 2,
    SideOfTheNeck = 3,
    TopOfTheFoot = 4,
}
